export const SWR_KEY = {
  product: 'product',
}
